import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  limit: 10,
  totalPage: 2,
  pageInfo: {},

  adminReviewList: [],
  adminReviewInfo: {
    reviewNo: '',
    userNo: '',
    orderNo: '',
    star: '',
    content: '',
    regDate: '',
    isActive: '',
    storeNo: '',
    isPinned: '',
    storeName: '',
    userName: '',
    repl: {
      reviewNo: '',
      content: '',
      regDate: ''
    },

    file: ''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
